import { asField } from 'transformers/fields';
import Section from 'types/Section';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const asSection = (o: Exclude<any, undefined | null>): Section => {
  return {
    ...o,
    exam_fields: (o.exam_fields || []).map(asField),
  };
};

export { asSection };
